import {
    Alert,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
} from '@mui/material';

interface Props {
    open?: boolean;
    accept?: boolean;
    onAccept?: () => void;
    onClose?: () => void;
}

export const PrivacyDialog = ({ open, accept, onAccept, onClose }: Props) => {
    const handleChangeAccept = () => {
        if (onAccept) onAccept();
        if (onClose) onClose();
    };

    return (
        <Dialog
            open={Boolean(open)}
            onClose={onClose}
            scroll="paper"
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            fullWidth
            maxWidth="md"
        >
            <DialogTitle id="scroll-dialog-title">
                Aviso de privacidad
            </DialogTitle>
            <DialogContent dividers>
                <Alert severity="info" style={{ textAlign: 'justify' }}>
                    Ministerio de Relaciones Exteriores, con domicilio en la
                    Calle 10 No 5 - 51 Palacio de San Carlos, Dirección
                    correspondencia Carrera 5 No 9 - 03 Edificio Marco Fidel
                    Suárez, PBX 3814000
                    <a target="_blank" href="http://www.cancilleria.gov.co/">
                        {' '}
                        www.cancilleria.gov.co
                    </a>{' '}
                    -{' '}
                    <a href="mailto:contactenos@cancilleria.gov.co">
                        contactenos@cancilleria.gov.co
                    </a>{' '}
                    Bogotá D.C., Colombia, es responsable de recolectar sus
                    datos personales, del uso que se le dé a los mismos y de su
                    protección conforme a la{' '}
                    <a
                        target="_blank"
                        href="https://www.cancilleria.gov.co/politica-tratamiento-informacion"
                    >
                        Política de Tratamiento de Datos Personales
                    </a>
                    .<br />
                    Su información personal será utilizada para proveer los
                    trámites, servicios o solicitudes de información por usted
                    solicitados y para evaluar la calidad del servicio que le
                    brindamos. Para los fines antes mencionados, requerimos
                    obtener los siguientes datos personales: identificación,
                    nombres y apellidos. Sus datos personales por deber legal
                    deben permanecer en la base de datos de trámites y servicios
                    y no podrán ser suprimidos. Los derechos pueden ser
                    ejercidos a través de los canales dispuestos por el
                    ministerio en la Política de Tratamiento de Datos Personales
                    del Ministerio de Relaciones Exteriores.
                    <br />
                    Sus datos personales pueden ser transferidos y tratados
                    dentro y fuera del país según lo establezca la ley. En ese
                    sentido, su información puede ser compartida con entidades
                    de control que lo requieran y para las entidades que
                    intervengan con el trámite o servicio solicitado en
                    cumplimiento de requisitos o notificaciones sobre el estado
                    o novedad del trámite o servicio.
                    <br />
                    <br />
                    Las solicitudes formuladas serán resueltas o contestadas
                    bajo los principios, términos y procedimientos contemplados
                    en el Código Contencioso Administrativo para el ejercicio
                    del Derecho de Petición{' '}
                    <b>
                        (Ley 1437 del 2011, artículo 14 modificada por la Ley
                        1755 de 2015)
                    </b>
                    .
                </Alert>
            </DialogContent>
            <DialogActions>
                <FormControlLabel
                    control={
                        <Checkbox
                            className="checkbox_boot"
                            id="policy"
                            checked={accept}
                            onChange={handleChangeAccept}
                        />
                    }
                    label="Autorizo"
                />
            </DialogActions>
        </Dialog>
    );
};
